import { TicketSource } from './ticket-source';

export interface DevelopmentTicket {
  developmentTicketId: string;
  ticketSource: TicketSource;
  ticketIdentifier: string;
  ticketLink: string;
}
